__turbopack_context__.v({
  "link": "vnk-_q_link",
  "linkWrapper": "vnk-_q_linkWrapper",
});
